/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContactDoublonSearchDto
 */
export interface ContactDoublonSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonSearchDto
     */
    idcontact?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContactDoublonSearchDto
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonSearchDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContactDoublonSearchDto
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContactDoublonSearchDto
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactDoublonSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContactDoublonSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactDoublonSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContactDoublonSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDoublonSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContactDoublonSearchDto interface.
 */
export function instanceOfContactDoublonSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactDoublonSearchDtoFromJSON(json: any): ContactDoublonSearchDto {
    return ContactDoublonSearchDtoFromJSONTyped(json, false);
}

export function ContactDoublonSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDoublonSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContactDoublonSearchDtoToJSON(value?: ContactDoublonSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontact': value.idcontact,
        'nom': value.nom,
        'prenom': value.prenom,
        'registreNational': value.registreNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'codesexe': value.codesexe,
        'idpersonne': value.idpersonne,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

